// Translations for SpaceLeadX SaaS
export const translations = {
  fr: {
    // Common
    common: {
      save: "Enregistrer",
      cancel: "Annuler",
      delete: "Supprimer",
      edit: "Modifier",
      create: "Créer",
      view: "Voir",
      search: "Rechercher",
      filter: "Filtrer",
      export: "Exporter",
      loading: "Chargement...",
      noData: "Aucune donnée",
      back: "Retour",
      next: "Suivant",
      previous: "Précédent",
      yes: "Oui",
      no: "Non",
      all: "Tous",
      required: "Requis",
      optional: "Optionnel",
      actions: "Actions",
      confirm: "Confirmer",
      close: "Fermer",
      error: "Une erreur est survenue",
      success: "Succès",
    },
    
    // Auth
    auth: {
      welcome: "Bienvenue",
      login: "Connexion",
      signIn: "Connexion",
      signInDescription: "Entrez vos identifiants pour accéder à votre espace",
      signInButton: "Se connecter",
      register: "Inscription",
      logout: "Déconnexion",
      email: "Courriel",
      emailPlaceholder: "vous@exemple.com",
      password: "Mot de passe",
      name: "Nom complet",
      forgotPassword: "Mot de passe oublié?",
      continueWithGoogle: "Continuer avec Google",
      orContinueWith: "ou par courriel",
      orByEmail: "ou par courriel",
      loginButton: "Se connecter",
      registerButton: "Créer mon compte",
      termsNotice: "En continuant, vous acceptez nos",
      termsLink: "conditions d'utilisation",
      tagline: "Gérez vos prospects. Convertissez plus.",
      connectOrCreate: "Connectez-vous ou créez votre compte",
      invalidCredentials: "Identifiants invalides",
      noAccount: "Vous n'avez pas de compte? Contactez l'administrateur.",
    },
    
    // Onboarding
    onboarding: {
      title: "Configuration",
      welcomeUser: "Bienvenue {name} ! Configurons votre espace de travail.",
      companyName: "Nom de votre entreprise",
      companyNameDesc: "Ce nom apparaîtra sur vos formulaires et pages de destination",
      companyPlaceholder: "Ex: Drains Expert Montréal",
      yourServices: "Vos services",
      servicesDesc: "Sélectionnez les services que vous offrez",
      addCustomService: "Ajouter un service personnalisé",
      servicesSelected: "{count} service(s) sélectionné(s)",
      serviceAreas: "Zones desservies",
      areasDesc: "Sélectionnez les villes où vous opérez",
      addCity: "Ajouter une ville",
      citiesSelected: "{count} ville(s) sélectionnée(s)",
      createWorkspace: "Créer mon espace de travail",
      continue: "Continuer",
    },
    
    // Dashboard
    dashboard: {
      title: "Tableau de bord",
      welcomeMessage: "Bienvenue, {name}. Voici un aperçu de {workspace}.",
      totalLeads: "Total Prospects",
      allTime: "Tous les temps",
      thisMonth: "Ce mois-ci",
      newLeads: "Nouveaux prospects",
      conversionRate: "Taux de conversion",
      leadsWon: "Prospects gagnés",
      pending: "En attente",
      toProcess: "À traiter",
      pipeline: "Pipeline",
      recentLeads: "Prospects récents",
      viewAll: "Voir tout",
      noLeadsYet: "Aucun prospect pour le moment",
      createFormPrompt: "Créez un formulaire pour commencer à recevoir des prospects.",
      leadSources: "Sources de prospects",
      quickStart: "Commencez à recevoir des prospects !",
      quickStartDesc: "Créez votre premier formulaire de soumission et intégrez-le sur votre site web ou page de destination.",
      newForm: "Nouveau formulaire",
      viewLeads: "Voir les prospects",
      createForm: "Créer un formulaire",
      createLandingPage: "Créer une page de destination",
    },
    
    // Leads (Prospects in French)
    leads: {
      title: "Prospects",
      totalCount: "{count} prospect(s) au total",
      pipelineView: "Vue Pipeline",
      exportCSV: "Exporter CSV",
      searchPlaceholder: "Rechercher par nom, courriel, téléphone...",
      allStatuses: "Tous les statuts",
      allSources: "Toutes les sources",
      contact: "Contact",
      service: "Service",
      city: "Ville",
      status: "Statut",
      source: "Source",
      date: "Date",
      noLeadsFound: "Aucun prospect trouvé",
      modifyFilters: "Modifiez vos filtres ou créez un formulaire pour recevoir des prospects.",
      page: "Page {current} sur {total}",
      createdOn: "Créé le {date}",
      urgent: "Urgent",
      
      // Pipeline
      pipelineTitle: "Pipeline",
      pipelineDesc: "Glissez-déposez les prospects pour changer leur statut",
      listView: "Vue Liste",
      noLeadInColumn: "Aucun prospect",
      justNow: "À l'instant",
      hoursAgo: "Il y a {hours}h",
      daysAgo: "Il y a {days}j",
      
      // Detail
      contactInfo: "Informations de contact",
      phone: "Téléphone",
      address: "Adresse",
      requestDetails: "Détails de la demande",
      requestedService: "Service demandé",
      problemType: "Type de problème",
      estimatedBudget: "Budget estimé",
      message: "Message",
      otherInfo: "Autres informations",
      notes: "Notes",
      addNote: "Ajouter une note",
      addNotePlaceholder: "Ajouter une note...",
      noNotes: "Aucune note pour le moment",
      tags: "Étiquettes",
      noTags: "Aucune étiquette",
      history: "Historique",
      leadCreated: "Prospect créé",
      firstContact: "Premier contact",
      converted: "Converti",
      statusUpdated: "Statut mis à jour",
      noteAdded: "Note ajoutée",
    },
    
    // Statuses
    status: {
      new: "Nouveau",
      contacted: "Contacté",
      appointment: "RDV",
      quote_sent: "Soumission envoyée",
      won: "Gagné",
      lost: "Perdu",
    },
    
    // Sources
    source: {
      maps: "Google Maps",
      ads: "Publicité",
      seo: "SEO",
      direct: "Direct",
      referral: "Référence",
      other: "Autre",
    },
    
    // Forms
    forms: {
      title: "Formulaires",
      description: "Créez et gérez vos formulaires de soumission",
      newForm: "Nouveau formulaire",
      noForms: "Aucun formulaire",
      noFormsDesc: "Créez votre premier formulaire pour commencer à recevoir des prospects.",
      createForm: "Créer un formulaire",
      fields: "champs",
      submissions: "soumissions",
      active: "Actif",
      inactive: "Inactif",
      copyEmbed: "Copier le code d'intégration",
      embedCopied: "Code d'intégration copié !",
      
      // Builder
      editForm: "Modifier le formulaire",
      newFormTitle: "Nouveau formulaire",
      settings: "Paramètres",
      formName: "Nom du formulaire",
      formNamePlaceholder: "Ex: Demande de soumission",
      formDescription: "Description",
      formDescPlaceholder: "Description interne (optionnel)",
      confirmationMessage: "Message de confirmation",
      confirmationPlaceholder: "Message affiché après soumission",
      defaultConfirmation: "Merci ! Nous vous contacterons sous peu.",
      notificationEmails: "Courriels de notification",
      notificationPlaceholder: "courriel1@exemple.com, courriel2@exemple.com",
      separateEmails: "Séparez les courriels par des virgules",
      antiSpam: "Protection anti-spam",
      honeypotEnabled: "Honeypot activé",
      addField: "Ajouter un champ",
      formFields: "Champs du formulaire",
      formFieldsDesc: "Cliquez sur un champ pour le modifier, glissez pour réorganiser",
      noFields: "Aucun champ",
      addFieldsPrompt: "Ajoutez des champs depuis le panneau de gauche",
      fieldLabel: "Libellé",
      fieldPlaceholder: "Texte indicatif",
      placeholderText: "Texte indicatif",
      fieldRequired: "Obligatoire",
      fieldOptions: "Options (une par ligne)",
      useMyServices: "Utiliser mes services",
      saveForm: "Enregistrer",
      saving: "Enregistrement...",
      formCreated: "Formulaire créé avec succès",
      formUpdated: "Formulaire mis à jour avec succès",
      formDeleted: "Formulaire supprimé",
      formActivated: "Formulaire activé",
      formDeactivated: "Formulaire désactivé",
      deleteConfirm: "Supprimer ce formulaire ?",
      formNameRequired: "Le nom du formulaire est requis",
      addAtLeastOneField: "Ajoutez au moins un champ",
      formNotFound: "Formulaire non trouvé",
      errorSaving: "Erreur lors de l'enregistrement",
    },
    
    // Field types
    fieldTypes: {
      text: "Texte",
      email: "Courriel",
      phone: "Téléphone",
      textarea: "Zone de texte",
      select: "Liste déroulante",
      checkbox: "Case à cocher",
      radio: "Boutons radio",
      date: "Date",
      number: "Nombre",
    },
    
    // Default field labels (French)
    defaultFields: {
      fullName: "Nom complet",
      fullNamePlaceholder: "Votre nom",
      phone: "Téléphone",
      phonePlaceholder: "514-555-1234",
      email: "Courriel",
      emailPlaceholder: "vous@exemple.com",
      city: "Ville",
      cityPlaceholder: "Votre ville",
      serviceRequired: "Service requis",
      message: "Message",
      messagePlaceholder: "Décrivez votre projet...",
      newField: "Nouveau champ",
    },
    
    // Landing Pages
    landingPages: {
      title: "Pages de destination",
      description: "Créez des pages de conversion optimisées pour le référencement",
      newPage: "Nouvelle page",
      noPages: "Aucune page de destination",
      noPagesDesc: "Créez des pages de conversion pour chaque service et ville que vous desservez.",
      createPage: "Créer une page de destination",
      published: "Publiée",
      draft: "Brouillon",
      seoTitle: "Titre SEO",
      seoDescription: "Description SEO",
      template: "Modèle",
      publish: "Publier",
      unpublish: "Dépublier",
      pagePublished: "Page publiée",
      pageUnpublished: "Page dépubliée",
      pageDeleted: "Page supprimée",
      deleteConfirm: "Supprimer cette page ?",
      seoTip: "Optimisez votre référencement local",
      seoTipDesc: "Créez une page de destination pour chaque combinaison service + ville. Chaque page génère automatiquement les balises SEO, le schéma LocalBusiness, et peut être indexée par Google pour attirer des clients locaux.",
    },
    
    // Settings
    settings: {
      title: "Paramètres",
      description: "Gérez les paramètres de votre espace de travail",
      company: "Entreprise",
      servicesAndCities: "Services et villes",
      team: "Équipe",
      companyInfo: "Informations de l'entreprise",
      companyInfoDesc: "Ces informations apparaîtront sur vos formulaires et pages de destination",
      companyName: "Nom de l'entreprise",
      phone: "Téléphone",
      email: "Courriel",
      website: "Site web",
      address: "Adresse",
      primaryColor: "Couleur principale",
      servicesOffered: "Services offerts",
      servicesDesc: "Les services que vous proposez à vos clients",
      addService: "Ajouter un service",
      noServices: "Aucun service ajouté",
      serviceAreas: "Zones desservies",
      areasDesc: "Les villes où vous offrez vos services",
      addCity: "Ajouter une ville",
      noCities: "Aucune ville ajoutée",
      saveServices: "Enregistrer les services et villes",
      teamTitle: "Équipe",
      teamDesc: "Gérez les membres de votre équipe",
      owner: "Propriétaire",
      teamInvites: "Invitations d'équipe",
      comingSoon: "Bientôt disponible en version Pro",
      currentPlan: "Plan actuel",
      leadsUsed: "{used} / {limit} prospects utilisés",
      upgrade: "Mise à niveau (bientôt)",
      settingsSaved: "Paramètres enregistrés",
      servicesUpdated: "Services et villes mis à jour",
    },
    
    // Public Form
    publicForm: {
      formNotFound: "Formulaire non trouvé",
      formNotFoundDesc: "Ce formulaire n'existe pas ou a été désactivé.",
      submitButton: "Envoyer ma demande",
      thankYou: "Merci !",
      requiredField: "Ce champ est requis",
      invalidEmail: "Courriel invalide",
      selectPlaceholder: "Sélectionner...",
    },
    
    // Navigation
    nav: {
      dashboard: "Tableau de bord",
      leads: "Prospects",
      pipeline: "Pipeline",
      forms: "Formulaires",
      landingPages: "Pages de destination",
      settings: "Paramètres",
      myAccount: "Mon compte",
    },
    
    // Workspace
    workspace: {
      title: "Espace de travail",
      freePlan: "Plan gratuit",
      proPlan: "Plan Pro",
    },
    
    // Preset services
    presetServices: [
      "Drain français",
      "Fissures de fondation",
      "Pavé uni",
      "Imperméabilisation",
      "Excavation",
      "Terrassement",
      "Réparation béton",
      "Installation gouttières",
    ],
    
    // Preset cities
    presetCities: [
      "Montréal",
      "Laval",
      "Longueuil",
      "Québec",
      "Gatineau",
      "Sherbrooke",
      "Trois-Rivières",
      "Drummondville",
    ],
  },
  
  en: {
    // Common
    common: {
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      create: "Create",
      view: "View",
      search: "Search",
      filter: "Filter",
      export: "Export",
      loading: "Loading...",
      noData: "No data",
      back: "Back",
      next: "Next",
      previous: "Previous",
      yes: "Yes",
      no: "No",
      all: "All",
      required: "Required",
      optional: "Optional",
      actions: "Actions",
      confirm: "Confirm",
      close: "Close",
      error: "An error occurred",
      success: "Success",
    },
    
    // Auth
    auth: {
      welcome: "Welcome",
      login: "Login",
      signIn: "Sign In",
      signInDescription: "Enter your credentials to access your space",
      signInButton: "Sign in",
      register: "Sign up",
      logout: "Logout",
      email: "Email",
      emailPlaceholder: "you@example.com",
      password: "Password",
      name: "Full name",
      forgotPassword: "Forgot password?",
      continueWithGoogle: "Continue with Google",
      orContinueWith: "or by email",
      orByEmail: "or by email",
      loginButton: "Sign in",
      registerButton: "Create my account",
      termsNotice: "By continuing, you accept our",
      termsLink: "terms of use",
      tagline: "Manage your leads. Convert more.",
      connectOrCreate: "Sign in or create your account",
      invalidCredentials: "Invalid credentials",
      noAccount: "Don't have an account? Contact the administrator.",
    },
    
    // Onboarding
    onboarding: {
      title: "Setup",
      welcomeUser: "Welcome {name}! Let's set up your workspace.",
      companyName: "Your company name",
      companyNameDesc: "This name will appear on your forms and landing pages",
      companyPlaceholder: "Ex: Montreal Drain Experts",
      yourServices: "Your services",
      servicesDesc: "Select the services you offer",
      addCustomService: "Add custom service",
      servicesSelected: "{count} service(s) selected",
      serviceAreas: "Service areas",
      areasDesc: "Select the cities where you operate",
      addCity: "Add a city",
      citiesSelected: "{count} city/cities selected",
      createWorkspace: "Create my workspace",
      continue: "Continue",
    },
    
    // Dashboard
    dashboard: {
      title: "Dashboard",
      welcomeMessage: "Welcome, {name}. Here's an overview of {workspace}.",
      totalLeads: "Total Leads",
      allTime: "All time",
      thisMonth: "This month",
      newLeads: "New leads",
      conversionRate: "Conversion rate",
      leadsWon: "Leads won",
      pending: "Pending",
      toProcess: "To process",
      pipeline: "Pipeline",
      recentLeads: "Recent leads",
      viewAll: "View all",
      noLeadsYet: "No leads yet",
      createFormPrompt: "Create a form to start receiving leads.",
      leadSources: "Lead sources",
      quickStart: "Start receiving leads!",
      quickStartDesc: "Create your first submission form and integrate it on your website or landing page.",
      newForm: "New form",
      viewLeads: "View leads",
      createForm: "Create a form",
      createLandingPage: "Create a landing page",
    },
    
    // Leads
    leads: {
      title: "Leads",
      totalCount: "{count} lead(s) total",
      pipelineView: "Pipeline View",
      exportCSV: "Export CSV",
      searchPlaceholder: "Search by name, email, phone...",
      allStatuses: "All statuses",
      allSources: "All sources",
      contact: "Contact",
      service: "Service",
      city: "City",
      status: "Status",
      source: "Source",
      date: "Date",
      noLeadsFound: "No leads found",
      modifyFilters: "Modify your filters or create a form to receive leads.",
      page: "Page {current} of {total}",
      createdOn: "Created on {date}",
      urgent: "Urgent",
      
      // Pipeline
      pipelineTitle: "Pipeline",
      pipelineDesc: "Drag and drop leads to change their status",
      listView: "List View",
      noLeadInColumn: "No lead",
      justNow: "Just now",
      hoursAgo: "{hours}h ago",
      daysAgo: "{days}d ago",
      
      // Detail
      contactInfo: "Contact information",
      phone: "Phone",
      address: "Address",
      requestDetails: "Request details",
      requestedService: "Requested service",
      problemType: "Problem type",
      estimatedBudget: "Estimated budget",
      message: "Message",
      otherInfo: "Other information",
      notes: "Notes",
      addNote: "Add note",
      addNotePlaceholder: "Add a note...",
      noNotes: "No notes yet",
      tags: "Tags",
      noTags: "No tags",
      history: "History",
      leadCreated: "Lead created",
      firstContact: "First contact",
      converted: "Converted",
      statusUpdated: "Status updated",
      noteAdded: "Note added",
    },
    
    // Statuses
    status: {
      new: "New",
      contacted: "Contacted",
      appointment: "Appointment",
      quote_sent: "Quote sent",
      won: "Won",
      lost: "Lost",
    },
    
    // Sources
    source: {
      maps: "Google Maps",
      ads: "Advertising",
      seo: "SEO",
      direct: "Direct",
      referral: "Referral",
      other: "Other",
    },
    
    // Forms
    forms: {
      title: "Forms",
      description: "Create and manage your lead capture forms",
      newForm: "New Form",
      noForms: "No forms yet",
      noFormsDesc: "Create your first form to start capturing leads.",
      createForm: "Create Form",
      fields: "fields",
      submissions: "submissions",
      active: "Active",
      inactive: "Inactive",
      copyEmbed: "Copy embed code",
      embedCopied: "Embed code copied!",
      
      // Builder
      editForm: "Edit Form",
      newFormTitle: "New Form",
      settings: "Settings",
      formName: "Form Name",
      formNamePlaceholder: "Ex: Quote Request",
      formDescription: "Description",
      formDescPlaceholder: "Internal description (optional)",
      confirmationMessage: "Confirmation Message",
      confirmationPlaceholder: "Message displayed after submission",
      defaultConfirmation: "Thank you! We will contact you shortly.",
      notificationEmails: "Notification Emails",
      notificationPlaceholder: "email1@example.com, email2@example.com",
      separateEmails: "Separate emails with commas",
      antiSpam: "Spam Protection",
      honeypotEnabled: "Honeypot enabled",
      addField: "Add Field",
      formFields: "Form Fields",
      formFieldsDesc: "Click a field to edit, drag to reorder",
      noFields: "No fields",
      addFieldsPrompt: "Add fields from the left panel",
      fieldLabel: "Label",
      fieldPlaceholder: "Placeholder",
      placeholderText: "Hint text",
      fieldRequired: "Required",
      fieldOptions: "Options (one per line)",
      useMyServices: "Use my services",
      saveForm: "Save",
      saving: "Saving...",
      formCreated: "Form created successfully",
      formUpdated: "Form updated successfully",
      formDeleted: "Form deleted",
      formActivated: "Form activated",
      formDeactivated: "Form deactivated",
      deleteConfirm: "Delete this form?",
      formNameRequired: "Form name is required",
      addAtLeastOneField: "Add at least one field",
      formNotFound: "Form not found",
      errorSaving: "Error saving form",
    },
    
    // Field types
    fieldTypes: {
      text: "Text",
      email: "Email",
      phone: "Phone Number",
      textarea: "Text Area",
      select: "Dropdown",
      checkbox: "Checkbox",
      radio: "Radio Buttons",
      date: "Date",
      number: "Number",
    },
    
    // Default field labels (English)
    defaultFields: {
      fullName: "Full Name",
      fullNamePlaceholder: "Your name",
      phone: "Phone Number",
      phonePlaceholder: "555-123-4567",
      email: "Email",
      emailPlaceholder: "you@example.com",
      city: "City",
      cityPlaceholder: "Your city",
      serviceRequired: "Service Requested",
      message: "Message",
      messagePlaceholder: "Describe your project...",
      newField: "New Field",
    },
    
    // Landing Pages
    landingPages: {
      title: "Landing Pages",
      description: "Create SEO-optimized conversion pages",
      newPage: "New page",
      noPages: "No landing pages",
      noPagesDesc: "Create conversion pages for each service and city you serve.",
      createPage: "Create a landing page",
      published: "Published",
      draft: "Draft",
      seoTitle: "SEO Title",
      seoDescription: "SEO Description",
      template: "Template",
      publish: "Publish",
      unpublish: "Unpublish",
      pagePublished: "Page published",
      pageUnpublished: "Page unpublished",
      pageDeleted: "Page deleted",
      deleteConfirm: "Delete this page?",
      seoTip: "Optimize your local SEO",
      seoTipDesc: "Create a landing page for each service + city combination. Each page automatically generates SEO tags, LocalBusiness schema, and can be indexed by Google to attract local customers.",
    },
    
    // Settings
    settings: {
      title: "Settings",
      description: "Manage your workspace settings",
      company: "Company",
      servicesAndCities: "Services & Cities",
      team: "Team",
      companyInfo: "Company information",
      companyInfoDesc: "This information will appear on your forms and landing pages",
      companyName: "Company name",
      phone: "Phone",
      email: "Email",
      website: "Website",
      address: "Address",
      primaryColor: "Primary color",
      servicesOffered: "Services offered",
      servicesDesc: "The services you offer to your clients",
      addService: "Add service",
      noServices: "No services added",
      serviceAreas: "Service areas",
      areasDesc: "The cities where you offer your services",
      addCity: "Add city",
      noCities: "No cities added",
      saveServices: "Save services and cities",
      teamTitle: "Team",
      teamDesc: "Manage your team members",
      owner: "Owner",
      teamInvites: "Team invitations",
      comingSoon: "Coming soon in Pro version",
      currentPlan: "Current plan",
      leadsUsed: "{used} / {limit} leads used",
      upgrade: "Upgrade (coming soon)",
      settingsSaved: "Settings saved",
      servicesUpdated: "Services and cities updated",
    },
    
    // Public Form
    publicForm: {
      formNotFound: "Form not found",
      formNotFoundDesc: "This form does not exist or has been disabled.",
      submitButton: "Send my request",
      thankYou: "Thank you!",
      requiredField: "This field is required",
      invalidEmail: "Invalid email",
      selectPlaceholder: "Select...",
    },
    
    // Navigation
    nav: {
      dashboard: "Dashboard",
      leads: "Leads",
      pipeline: "Pipeline",
      forms: "Forms",
      landingPages: "Landing Pages",
      settings: "Settings",
      myAccount: "My account",
    },
    
    // Workspace
    workspace: {
      title: "Workspace",
      freePlan: "Free plan",
      proPlan: "Pro plan",
    },
    
    // Preset services (in English)
    presetServices: [
      "French drain",
      "Foundation cracks",
      "Paving stones",
      "Waterproofing",
      "Excavation",
      "Landscaping",
      "Concrete repair",
      "Gutter installation",
    ],
    
    // Preset cities
    presetCities: [
      "Montreal",
      "Laval",
      "Longueuil",
      "Quebec City",
      "Gatineau",
      "Sherbrooke",
      "Trois-Rivières",
      "Drummondville",
    ],
  },
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang];
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      return key;
    }
  }
  
  return value || key;
};

export const formatTranslation = (text, params = {}) => {
  if (!text) return '';
  return text.replace(/{(\w+)}/g, (match, key) => params[key] !== undefined ? params[key] : match);
};
